import { z } from 'zod'
import { zId, zIsoDate } from '../common'
import { zWebhookEvent } from '../enums'

/** Payload shape sent to the destination. CMS packages create `cms_enriched`. */
export const WEBHOOK_PAYLOAD_PROFILES = ['slim', 'cms_enriched'] as const
export type WebhookPayloadProfile = (typeof WEBHOOK_PAYLOAD_PROFILES)[number]
export const zWebhookPayloadProfile = z.enum(WEBHOOK_PAYLOAD_PROFILES)

export const zWebhookEndpoint = z.object({
  id: zId,
  tenantId: zId,
  url: z.string(),
  events: z.array(zWebhookEvent),
  active: z.boolean(),
  hasSecret: z.boolean(),
  // Defaulted: older payloads without the field still parse; CMS packages set cms_enriched.
  payloadProfile: zWebhookPayloadProfile.optional().default('slim'),
  createdAt: zIsoDate,
  updatedAt: zIsoDate,
})
export type WebhookEndpoint = z.infer<typeof zWebhookEndpoint>

// Secret is returned ONCE, on create or rotate.
export const zWebhookEndpointWithSecret = zWebhookEndpoint.extend({
  secret: z.string(),
})
export type WebhookEndpointWithSecret = z.infer<typeof zWebhookEndpointWithSecret>

export const zWebhookDelivery = z.object({
  id: zId,
  tenantId: zId,
  articleId: zId,
  webhookEndpointId: zId,
  event: z.string(),
  idempotencyKey: z.string(),
  responseStatus: z.number().nullable(),
  attempts: z.number(),
  deliveredAt: zIsoDate.nullable(),
  failedAt: zIsoDate.nullable(),
  createdAt: zIsoDate,
  updatedAt: zIsoDate,
})
export type WebhookDelivery = z.infer<typeof zWebhookDelivery>
